<template>
  <el-cascader
    v-loading="!options"
    :options="options || []"
    :filterable="true"
    :props="{ expandTrigger: 'hover' }"
    v-model="selectedValue">
  </el-cascader>
</template>

<script>
  export default {
    name: 'ConsultantSelect',
    props: {
      value: {
        type: Number
      }
    },
    methods: {
      convertData (item) {
        const ret = {
          label: item.name,
          value: item.id,
          children: []
        }
        for (const consultant of item.consultants || []) {
          ret.children.push({
            label: consultant.name,
            value: consultant.id
          })
        }
        return ret
      },
      findByLast (value) {
        const ret = []
        for (const item of this.options) {
          ret.push(item.value)
          if (!item.children) {
            if (item.value === value) return ret
          } else {
            for (const child of item.children) {
              if (child.value === value) {
                ret.push(value)
                return ret
              }
            }
          }
          ret.pop()
        }
        return ret
      }
    },
    computed: {
      options () {
        const shops = this.$store.state.data.ConsultantsOfShop
        if (!shops) {
          return null
        }

        const options = []
        if (shops.length === 1) {
          for (const child of this.convertData(shops[0]).children) {
            options.push(child)
          }
        } else {
          for (const item of shops) {
            options.push(this.convertData(item))
          }
        }
        return options
      },
      selectedValue: {
        get () {
          return this.findByLast(this.value)
        },
        set (value) {
          const last = value[value.length - 1]
          if (last !== this.value) {
            this.$emit('input', last)
          }
        }
      }
    }
  }
</script>

<style scoped>
</style>
